// const moment = require('moment')

const formRows = [
  {
    span: 24,
    labelCol: { span: 2 },
    label: '视频名称',
    component: 'AInput',
    placeholder: '请输入标题',
    prop: 'name',
    allowClear: true,
  },
  {
    span: 24,
    labelCol: { span: 2 },
    label: '视频封面',
    component: 'AUpload',
    maxLength: 1,
    tips: '请上传jpg/jpeg/png，且不超过1m',
    uploadTypeMap: 'jpg,jpeg,png',
    prop: 'fileImgUrl', // 首图
  },
  {
    span: 12,
    label: '行业领域',
    component: 'ASelect',
    prop: 'videoType',
    placeholder: '请选择行业领域',
    allowClear: true,
    list: [
      {
        label: '集成电路',
        value: '1'
      },
      {
        label: '生物医药',
        value: '2'
      },
      {
        label: '人工智能',
        value: '3'
      },
      {
        label: '新能源汽车',
        value: '4'
      },
      {
        label: '高端装备制造',
        value: '5'
      },
      {
        label: '航空航天',
        value: '6'
      },
      {
        label: '新一代信息技术',
        value: '7'
      },
      {
        label: '新材料',
        value: '8'
      },
      {
        label: '新兴数字产业',
        value: '9'
      },
      {
        label: '现代农业',
        value: '10'
      },
      {
        label: '现代服务',
        value: '11'
      }
    ]
  },
  {
    span: 24,
    labelCol: { span: 2 },
    label: '视频简介',
    component: 'ATextArea',
    prop: 'content',
  },
  {
    span: 24,
    labelCol: { span: 2 },
    label: '视频资源',
    component: 'SpliceUploadVideo',
    maxSize: 1024 * 1000 * 1000 * 100, // 最大5g
    uploadTypeMap: 'mp4,webm,mkv,x-matroska',
    prop: 'fileId',
  },
];

const formRules = {
  name: [
    { required: true, message: '视频名称不能为空', trigger: 'blur' },
    { min: 1, max: 100, message: '输入的字数不能超过100个', trigger: 'blur' },
  ],
  content: [{ required: false, message: '视频简介不能为空', trigger: 'blur' }],
  fileImgUrl: [{ required: true, message: '视频简介不能为空', trigger: 'blur' }],
  fileId: [{ required: true, message: '视频资源不能为空', trigger: 'blur' }],
};

const formInfo = [
  { label: '标题', value: '-', key: 'title' },
  { label: '文章类型', value: '-', key: 'informationTypeStr' },
  { label: '首图', value: '-', key: 'picture', isVHtml: true },
  { label: '内容', value: '-', key: 'content', isVHtml: true },
  { label: '附件', value: '-', key: 'annex', isVHtml: true },
];

module.exports = {
  formRows,
  formRules,
  formInfo,
};
